import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '../assets/img/logo.png'


const _hoisted_1 = {
  class: "shadow-lg bg-white backdrop-blur-[2rem] fixed w-full z-[999]",
  style: {"transition":"color 350ms ease,background-color 350ms ease"}
}
const _hoisted_2 = { class: "flex items-center justify-between h-16 mx-auto max-w-screen-2xl px-8" }
const _hoisted_3 = { class: "flex items-center" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("img", {
  alt: "Vue logo",
  class: "h-11",
  src: _imports_0
}, null, -1)
const _hoisted_5 = { class: "flex items-center justify-end flex-1" }
const _hoisted_6 = { class: "hidden md:flex uppercase text-gray-500 tracking-wide font-bold text-xs space-x-4" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("a", {
  href: "javascript:void(0);",
  class: "block sm:px-5 sm:py-2.5 px-2 py-1 text-sm font-medium text-white bg-blue-800 hover:bg-blue-700 transition",
  "data-v-0348960e": ""
}, " Faça um Orçamento ", -1)
const _hoisted_8 = { class: "md:hidden group relative" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("span", { class: "sr-only" }, "Toggle menu", -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  class: "w-5 h-5",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor",
  "stroke-width": "2"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    d: "M4 6h16M4 12h16M4 18h16"
  })
], -1)
const _hoisted_11 = [
  _hoisted_9,
  _hoisted_10
]
const _hoisted_12 = {
  class: "w-42 space-y-1 p-3 text-sm text-gray-700",
  "aria-labelledby": "dropdownRadioButton"
}
const _hoisted_13 = { class: "text-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("header", _hoisted_1, [
    _createElementVNode("nav", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_router_link, {
          id: "logo-url",
          to: "#home"
        }, {
          default: _withCtx(() => [
            _hoisted_4
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createVNode(_component_router_link, {
            to: "#home",
            class: "block h-16 leading-[4rem] border-b-4 border-transparent hover:text-sky-700 hover:border-current"
          }, {
            default: _withCtx(() => [
              _createTextVNode(" Home ")
            ]),
            _: 1
          }),
          _createVNode(_component_router_link, {
            to: "#sobre",
            class: "block h-16 leading-[4rem] border-b-4 border-transparent hover:text-sky-700 hover:border-current"
          }, {
            default: _withCtx(() => [
              _createTextVNode(" Sobre ")
            ]),
            _: 1
          }),
          _createVNode(_component_router_link, {
            to: "#produtos",
            class: "block h-16 leading-[4rem] border-b-4 border-transparent hover:text-sky-700 hover:border-current"
          }, {
            default: _withCtx(() => [
              _createTextVNode(" Produtos ")
            ]),
            _: 1
          }),
          _createVNode(_component_router_link, {
            to: "#feedback",
            class: "block h-16 leading-[4rem] border-b-4 border-transparent hover:text-sky-700 hover:border-current"
          }, {
            default: _withCtx(() => [
              _createTextVNode(" Feedback ")
            ]),
            _: 1
          }),
          _createVNode(_component_router_link, {
            to: "#orcamento",
            class: "h-16 leading-[4rem] border-transparent hover:border-current flex items-center"
          }, {
            default: _withCtx(() => [
              _hoisted_7
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("button", {
            onClick: _cache[0] || (_cache[0] = ($event: any) => ($data.showDropdownNav = !$data.showDropdownNav)),
            class: "group relative block p-2.5 text-gray-600 transition bg-gray-100 hover:text-gray-600/75"
          }, _hoisted_11),
          _withDirectives(_createElementVNode("div", {
            onMouseleave: _cache[1] || (_cache[1] = ($event: any) => ($data.showDropdownNav = 0)),
            class: "hidden w-[100vw] group-hover:block delay-100 absolute z-10 -right-8 mt-3 bg-white divide-y divide-gray-100 shadow-xl border border-gray-300"
          }, [
            _createElementVNode("ul", _hoisted_12, [
              _createElementVNode("li", _hoisted_13, [
                _createVNode(_component_router_link, {
                  to: "#home",
                  class: "block h-16 leading-[4rem] border-b-4 border-transparent hover:text-sky-700 hover:border-current"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(" Home ")
                  ]),
                  _: 1
                }),
                _createVNode(_component_router_link, {
                  to: "#sobre",
                  class: "block h-16 leading-[4rem] border-b-4 border-transparent hover:text-sky-700 hover:border-current"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(" Sobre ")
                  ]),
                  _: 1
                }),
                _createVNode(_component_router_link, {
                  to: "#produtos",
                  class: "block h-16 leading-[4rem] border-b-4 border-transparent hover:text-sky-700 hover:border-current"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(" Produtos ")
                  ]),
                  _: 1
                }),
                _createVNode(_component_router_link, {
                  to: "#feedback",
                  class: "block h-16 leading-[4rem] border-b-4 border-transparent hover:text-sky-700 hover:border-current"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(" Feedback ")
                  ]),
                  _: 1
                }),
                _createVNode(_component_router_link, {
                  to: "#orcamento",
                  class: "block sm:px-5 sm:py-2.5 px-2 py-1 text-sm font-medium text-white bg-blue-800 hover:bg-blue-700 transition",
                  "data-v-0348960e": ""
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(" Faça um Orçamento ")
                  ]),
                  _: 1
                })
              ])
            ])
          ], 544), [
            [_vShow, $data.showDropdownNav]
          ])
        ])
      ])
    ])
  ]))
}